/* eslint-disable @typescript-eslint/no-var-requires */
export const phoenixShopSuggestedPlacesDetails = require('./phoenixShopSuggestedPlacesDetailsQuery.graphql');
export const phoenixShopSuggestedPlacesQuery = require('./phoenixShopSuggestedPlacesQuery.graphql');
export const phoenixShopAdvSearchInventoryDate = require('./phoenixShopAdvSearchInventoryDate.graphql');
